/** The WhatsApp community where users ask for help and talk to the team. */
export const WHATSAPP_COMMUNITY_URL =
  "https://chat.whatsapp.com/JJBSKKzz5z1AIn8nFpol1k";
